module.exports = __webpack_public_path__ + "static/media/healthTabSelected.637775e9.png";